import React, { useState,useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { setYearList, setMonthList, setDateRange,formatDate,DownloadFile } from './Function';
import { Row,Col,Card,Table,Button,Placeholder,Form,InputGroup,Spinner } from 'react-bootstrap';
const CalendarArchives = () => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const { t } = useTranslation();
    const[isLoading, setLoading] = useState(true);
    const[isLoadMore, setLoadMore] = useState(true);
    const[Rows, setRows] = useState(0);
    const[Calendars,setCalendars]=useState([]);    
    const[keyword, setKeyword] = useState('');
    const[year, setYear] = useState(0);
    const[month, setMonth] = useState(0);
    const KeywordChange = (e) => setKeyword(e.target.value.trim() || '');
    const YearChange = (e) => setYear(Number(e.target.value) || 0);
    const MonthChange = (e) => setMonth(Number(e.target.value) || 0);
    useEffect(()=>
    {
        fetchCalendar(true);
        // eslint-disable-next-line
    },[])
    const fetchCalendar = async (isReset) => 
    {
        if (isReset === true) 
        {
            setRows(0);
            setCalendars([]);
        }
        try 
        {
            setLoading(true);
            var keywordText = keyword || 'none';
            const { startDate, endDate } = setDateRange(year, month, 0, 1, 0);
            const currentRows = isReset ? 0 : Rows;
            const callApi = global.config.API_URL + `calendar/list/${keywordText}/${startDate}/${endDate}/${currentRows}`;
            if(global.config.IsPrint) console.info('CalendarList : API', callApi);
            const response = await fetch(callApi);
            const result = await response.json();
            if(result.length > 0 )
            {
                Promise.all(
                    result.map(e => {
                        const fetch1 = fetch(global.config.API_URL + "upload/details/0/" + e.ac_id + "/acCalendar")
                            .then(upp => upp.json());
                        const fetch2 = fetch(global.config.API_URL + "upload/details/0/" + e.ac_id + "/acCalendarHi")
                            .then(upb => upb.json());
                        return Promise.all([fetch1, fetch2])
                            .then(([upp, upb]) => {
                                return {
                                    ...e,
                                    upp,
                                    upb
                                };
                            });
                    })
                ).then(allResponse => {   
                    allResponse.forEach((el, i) => {
                        result[i].acCalendar = el.upp;
                        result[i].acCalendarHi = el.upb;
                    });
                    setCalendars(prevResults => Rows === 0 ? result : [...prevResults, ...result]);
                    setRows(currentRows + 30);           
                    setLoadMore(true);
                }).catch(error => {
                    console.error('Calendar File :', error);
                    setLoading(false);
                });
            }
            else
            {
                setLoadMore(false);
            }
            if( global.config.IsPrint === true ) { console.info('fetchCalendar : Result',result); }
        } catch (error) 
        {
            console.error('fetchCalendar : Error', error.message);
        }
        finally 
        {
            setLoading(false);
        }
    };
    const handleSubmit = (e) => 
    {
        e.preventDefault();
        if (!keyword && year === 0 && month === 0) 
        {
            alert(t('FilterAlert'));
            return;
        }
        fetchCalendar(true);
    };
    return (
        <Card className='bg-secondary-subtle mb-4'>
            <Card.Header className='text-center fs-3 text-uppercase' data-aos="flip-up" data-aos-duration="1000">
                {t('AcademicCalendar')}
            </Card.Header>
            <Card.Body>
                <Card className=' mb-3'>
                    <Card.Body>
                        <Form onSubmit={handleSubmit}>
                            <div className='mb-2 fw-bold'>{t('FilterSearch')}</div>
                            <Row className='g-2'>
                                <Col md={6} data-aos="fade-right" data-aos-duration="1000">
                                    <Form.Control type="text" placeholder={t('FilterPlaceholder')} onChange={KeywordChange} value={keyword} />
                                </Col>
                                <Col md={6} data-aos="fade-right" data-aos-duration="1000">
                                    <InputGroup>
                                        <Form.Select onChange={YearChange} value={year}>
                                            <option value={0}>{t('FilterYear')}</option>
                                            {setYearList(0, 1).map((year) => (
                                                <option key={year} value={year}>
                                                    {year}
                                                </option>
                                            ))}
                                        </Form.Select>
                                        <Form.Select onChange={MonthChange} value={month}>
                                            <option value={0}>{t('FilterMonth')}</option>
                                            {setMonthList().map(({ value, label }) => (
                                                <option key={value} value={value}>
                                                    {label}
                                                </option>
                                            ))}
                                        </Form.Select>
                                        <Button type="submit" className='btn btn-info'><i className="bi bi-search"></i> {t('FilterSearch')}</Button>
                                    </InputGroup>                                    
                                </Col>
                            </Row>
                        </Form>
                    </Card.Body>
                </Card>
                <Table responsive bordered className='rounded-top text-center overflow-hidden mb-0'>
                    <thead>
                    <tr>
                        <th className='w-50'>{t('Title')}</th>
                        <th>{t('UploadDate')}</th>
                        <th>{t('Download')}</th>
                    </tr>
                    </thead>
                    {isLoading ? (
                    <tbody>
                        {[...Array(10)].map((_,index)=>(
                        <tr key={index}>
                            <th className="table-success w-75"><Placeholder xs={10} /></th>                            
                            <td className="text-center"><Placeholder xs={12} /></td>
                            <td className="text-center"><Button className="btn btn-light w-75"><Placeholder xs={12} /></Button></td>
                        </tr>
                        ))}
                    </tbody>
                    ) : (
                    <tbody>
                        {Calendars.map((ac,index)=>(
                        <tr key={index}>
                            <th className="table-success" dangerouslySetInnerHTML={{ __html: appLanguage === 'hi' ? (ac.ac_display_en === "1" ? ac.ac_name_hi || '' : ac.ac_name_hi || ac.ac_name) : ac.ac_name }}></th>
                            <td className="text-center">{formatDate(ac.ac_date)}</td>
                            <td className="text-center" dangerouslySetInnerHTML={{ __html: DownloadFile(appLanguage,ac.acCalendar,ac.acCalendarHi)}} />
                        </tr>
                        ))}
                    </tbody>
                    )}
                </Table>                
                {isLoadMore &&
                <div className='text-center p-3'>
                    <Button className='btn btn-info mt-3' onClick={() => fetchCalendar(false)} disabled={isLoading}>
                        {isLoading ? (
                        <React.Fragment>
                            <Spinner animation="grow" variant="light" size="sm" />
                            <Spinner animation="grow" variant="danger" size="sm" />
                            <span className='ms-2'>{t('PleaseWait')}</span>
                        </React.Fragment>
                        ) : t('LoadMore')}
                    </Button>
                </div>}            
            </Card.Body>
        </Card>
    );
}
export default CalendarArchives;